<template>

	<tr>
		<template  v-if="claimData && dummyClaim">
			<td>
				<span v-html="dummyClaim.orderOperationClaimService.ninaCode + ' - ' + dummyClaim.orderOperationClaimService.description"></span>
				<!-- {{ dummyClaim.orderOperationClaimService.category }} - {{ dummyClaim.orderOperationClaimService.ninaCode }} {{ dummyClaim.orderOperationClaimService.ninaCode }}  -->
				<!-- {{ dummyClaim.orderOperationClaimService.ninaCode }} - {{ dummyClaim.orderOperationClaimService.description }}  -->
				<i class="fa fa-exclamation-circle" title="Service code already deleted." v-if="!dummyClaim.orderOperationClaimService.status"></i>
			</td>
			<td>{{ dummyClaim.quantity }}</td>
			<td>{{ dummyClaim.orderOperationClaimService.rate | numberPriceFormatterWithDollarSign }}</td>
			<td>{{ dummyClaim.orderOperationClaimService.rate * dummyClaim.quantity | numberPriceFormatterWithDollarSign }}</td>
			<td style="text-align:center;">
				<i class="fa fa-info-circle" style="cursor:pointer; font-size:20px;" :title="dummyClaim.details"></i>
			</td>
			<td style="text-align:right;">
				<button type="button" class="button is-info" @click="openEditClaimline(false)">
					<i class="fa fa-pencil"></i>
				</button>
			</td>
		</template>

		<template v-else>
			<td style="display:flex;">
				<b-select expanded v-model="activity_type" style="width:50%;" placeholder="Activity Type">
	                <option v-for="(category, key) in filteredActivityTypes">
	                    {{ category }}
	                </option>
	            </b-select>
				<b-select expanded v-model="codeHandler" :disabled="!activity_type" style="width:50%;" placeholder="Service Code">
	                <option :value="code" v-for="(code, key) in serviceCodes">
	                    {{ code.ninaCode }} - {{ code.description }}
	                </option>
	            </b-select>
			</td>
			<td>
				<b-input v-model="quantity"></b-input>
			</td>
			<td>
				<b-input disabled readonly v-model="rate"></b-input>
			</td>
			<td>
				<b-input disabled readonly :value="total | numberPriceFormatterWithDollarSign"></b-input>
			</td>
			<td>
				<b-modal :active="modal" has-modal-card trap-focus aria-role="dialog" aria-modal>
					<div class="modal-card" style="min-width:500px;">
		                <header class="modal-card-head">
		                    <p class="modal-card-title">Claim Line Note</p>
		                </header>
		                <section class="modal-card-body">
					          <b-input type="textarea" v-model="notes"></b-input>
		                </section>
		                <footer class="modal-card-foot">
		                    <button class="button" style="position: absolute; left: 20px;" type="button" @click="notes = claim.details, modal = false">Cancel</button>
		                    <button class="button is-info" type="button" @click="modal = false">Save</button>
		                    <!-- <button class="button" type="button" @click="modal = false">Close</button> -->
		                </footer>
		            </div>
	        	</b-modal>
				<b-button @click="modal = true">Notes</b-button>
			</td>
			<td>
				<b-button type="is-warning" @click="updateClaimLine">
					<i class="fa fa-save"></i>
				</b-button>
				<b-button type="is-danger" @click="openEditClaimline(true)">
					<i class="fa fa-minus"></i>
				</b-button>
			</td>
		</template>
	</tr>


</template>
<script>
import { OrderOperationClaimServiceService } from "@/services/orderOperationClaimService.service";
import { JsonDenormalizer } from "@/helpers/JsonDenormalizer";
import { OrderOperationClaimLineService } from "@/services/orderOperationClaimLine.service";
export default {
	props: [ 'activityTypes', 'claim', 'form', 'index' ],
    data: () => ({
    	modal: false,
		activity_type: null,
    	code: null,
		quantity: 1,
		rate: 0.00,
		notes: null,
		serviceCodes: [],
		codeHandler: null,
		claimData: true,
		dummyClaim: null,
    }),
    computed: {
		total() {
			return this.quantity * this.rate;
		},
		filteredActivityTypes() {
			if (this.form.issued_to) {
				return this.activityTypes.filter(element => element.firmId == this.form.issued_to.child_id).map(element => element.category);
			}
			return [];
		},
    },
    watch: {
		'activity_type'(value) {
			OrderOperationClaimServiceService.all({category: value}).then(response => {
				this.serviceCodes = JsonDenormalizer.denormalize(response).filter(element => element.status == 1);
			});
		},
		'codeHandler'(codeHandler) {
			this.code = codeHandler.id;
			this.rate = codeHandler.rate;
		},
    },
    methods: {
    	openEditClaimline(value) {
    		this.$emit('updateActiveClaimLine', this.index, value)
    		this.claimData = value;
    	},
    	generateData() {
    		return {
    			code: this.code,
    			quantity: this.quantity,
    			rate: this.rate,
    			notes: this.notes
    		};
    	},

		updateClaimLine() {
			let data = {
				orderOperationClaimServiceId: this.code,
				details: this.notes,
				quantity: this.quantity
			};
			OrderOperationClaimLineService.updateClaimLine(this.claim.id, data).then(response => {
				this.$buefy.toast.open({
		          message: "Success",
		          type: "is-info",
		          position: "is-top-right"
		        });
		        this.claimData = true;
				let newValue = JsonDenormalizer.denormalize(response);
		        // console.log(newValue);
		        this.dummyClaim = newValue;
		        this.$emit('updateLocalClaim', this.index, newValue);
    			this.$emit('updateActiveClaimLine', this.index, true)
			});
		},
    },
    mounted() {
		this.quantity      = this.claim.quantity;
		this.notes         = this.claim.details;
		this.activity_type = this.claim.orderOperationClaimService.category;
		// this.code       = this.claim.orderOperationClaimService.id;
		this.codeHandler   = this.claim.orderOperationClaimService;

		this.dummyClaim = this.claim;
    }

};
</script>

<style scoped>
	.fa-exclamation-circle {
		color: red;
	}
</style>



// WEBPACK FOOTER //
// src/components/pages/Operations/editClaimLines.vue